import React from 'react';
import styled from 'styled-components';
import { COLORS } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

import { STATUS_CARDS } from 'constants/student-transfer';

const Wrapper = styled(Text)`
  width: fit-content;
  padding: 4px !important;
  border-radius: 4px;
  background-color: ${({ bgColor }) => bgColor || COLORS.ORANGE_XXLIGHT};
`;

const TransferStatusCards = ({ cardType }) => {
  const { text, bgColor } = STATUS_CARDS[cardType] || {};

  if (!text) return '-';

  return (
    <Wrapper variant="body3" bgColor={bgColor}>
      {text}
    </Wrapper>
  );
};

export default TransferStatusCards;
